import { ExtendedProductPageSelectorOption } from './exploreOptions';

const getSelectedAttributeValue = (options: ExtendedProductPageSelectorOption[]) =>
  options.find((option) => option.selected)?.name;

export default getSelectedAttributeValue;
